import { Box, Grid, IconButton, Switch, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EditIcon from '../../images/Edit.svg'
import { Edit } from '@mui/icons-material'
import CoachSideBar from './Profile/CoachSideBar'
import Navbar from '../Navbar'
import { useDispatch, useSelector } from 'react-redux'
import { getAvailabilityById } from '../../actions/userAuth'
import { useNavigate } from 'react-router-dom'
import Layout from '../../assets/Layout'
import UserLayout from '../../assets/UserLayout'

function CoachAvailablity() {
    const [availability, setAvailability] = useState([]);
    const { user } = useSelector((state) => ({ ...state }));
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAvailabilityById({ id: user._id }, (data) => {
            setAvailability(data.data.data);
        }))
    }, [user]);

    const days = {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday"
    };

    const fullDayName = (date) => {
        console.log(date);
        var temp = date.split(",");
        return days[temp[0]];
    }

    function calculateTimeDifference(startTime, endTime) {
        var start = new Date("1970-01-01 " + startTime);
        var end = new Date("1970-01-01 " + endTime);

        var diffInMilliseconds = end - start;
        var diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

        return diffInMinutes;
    }

    const navigate = useNavigate();

    return (

        <>
            <Layout>
                <UserLayout userRole={"coach"}>
                    <Box mt={8}>
                        {
                            availability && availability.length > 0
                                ?
                                availability.map((item, index) => (
                                    <>
                                        <Box
                                            key={index}
                                            sx={{
                                                width: '100%',
                                                height: 'auto',
                                                backgroundColor: '#F8FAFF',
                                                border: '1px solid #005CF64D',
                                                borderImageSlice: 1,
                                                borderRadius: '10px',
                                                px: 2,
                                                py: 2,
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between'
                                                }}
                                            >
                                                <Typography className='text1Bold'>{fullDayName(item.availability[0].selectedDate)} to {fullDayName(item.availability[item.availability.length - 1].selectedDate)} <span style={{ opacity: '0.5' }}>({item.availability[0].selectedDate.split(",")[1]} to {item.availability[item.availability.length - 1].selectedDate.split(",")[1]})</span></Typography>
                                                <Box>
                                                    <IconButton
                                                        style={{
                                                            border: '1px solid #d2d2d2',
                                                            backgroundClip: 'padding-box, border-box',
                                                            padding: '5px',
                                                            borderRadius: '50%',
                                                            cursor: 'pointer'
                                                        }}
                                                        aria-label="Edit"
                                                        onClick={() => navigate(`/coach/edit-availibility/${item._id}`)}
                                                    >
                                                        <img src={EditIcon} id={"Edit"} alt="Edit Icon" />
                                                    </IconButton>
                                                    {/* <Switch
                                                    checked={showEmail}
                                                    onChange={handleSwitchOneChange}
                                                    style={{ color: '#2544EE' }}
                                                    inputProps={{ 'aria-label': 'switch one' }}
                                                /> */}
                                                </Box>
                                            </Box>
                                            {item.availability.map((ava, index) => (
                                                <>
                                                    <Typography className='text2Bold'>{fullDayName(ava.selectedDate)}<span style={{ opacity: '0.5' }}>({ava.selectedDate.split(",")[1]}, 2023)</span></Typography>
                                                    <Grid container>
                                                        <Grid item md={8} xs={12}>
                                                            <Grid container spacing={2} xs={12}>
                                                                <Grid item md={6} xs={12}>
                                                                    <Typography className='text2Bold'
                                                                        sx={{
                                                                            border: '1px solid #2544EE',
                                                                            width: 'fit-content',
                                                                            color: '#2544EE',
                                                                            px: 2,
                                                                            py: 1,
                                                                            borderRadius: '16px',
                                                                            my: 1
                                                                        }}
                                                                    >
                                                                        {ava.startTime} - {ava.endTime} | Slot : {calculateTimeDifference(ava.startTime, ava.endTime)}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            ))}

                                        </Box>
                                    </>
                                ))
                                :
                                <Typography align='center'>No Availability</Typography>
                        }
                    </Box>
                </UserLayout>
            </Layout>
        </>
    )
}

export default CoachAvailablity